// Add password fields to editForm

import React, { useEffect, useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserShield } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const GetAllAdmins = () => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deleteModal, setDeleteModal] = useState({ open: false, adminId: null });
  const [isDeleteChecked, setIsDeleteChecked] = useState(false);
  // Edit modal state
  const [editModal, setEditModal] = useState({ open: false, admin: null });
  const [editForm, setEditForm] = useState({ name: '', email: '', mobileNumber: '', role: '' });
  const [editLoading, setEditLoading] = useState(false);
  const [editError, setEditError] = useState(null);
  const [editPasswords, setEditPasswords] = useState({ password: '', confirmPassword: '' });

  useEffect(() => {
    const fetchAdmins = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/super/admin/get/all/admins`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        console.log("get all Admins :", response);

        // Show success toast if status is 200
        if (response.status === 200) {
          // toast.success("Admins fetched successfully");
        }

        setAdmins(response.data.data);
      } catch (err) {
        setError("Failed to fetch admins");
      } finally {
        setLoading(false);
      }
    };
    fetchAdmins();
  }, []);

  // for deleting sub admins
  const handleDelete = async (adminId) => {
    console.log("Deleting admin with ID:", adminId);
    console.log("Final API URL:", `${process.env.REACT_APP_API_BASE_URL}/super/admin/delete/subadmin/${adminId}`);
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/super/admin/delete/subadmin/${adminId}`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          validateStatus: () => true, // prevents auto-retry
        }

      );
      console.log("API URL:", `${process.env.REACT_APP_API_BASE_URL}/super/admin/delete/subadmin/${adminId}`);

      console.log("Delete  subAdmin Response:", response);

      if (response.status === 200) {
        toast.success("Subadmin deleted successfully");
        setAdmins((prevAdmins) =>
          prevAdmins.filter((admin) => admin._id !== adminId)
        );

      } else if (response.status === 403) {
        toast.error("You cannot delete a superadmin");
      } else if (response.status === 404) {
        toast.error("Subadmin not found");
      } else if (response.status === 500) {
        toast.error("Server error while deleting sub-admin");
      }

    } catch (error) {
      toast.error("An error occurred while deleting the subadmin");
    }
  };

  // Fetch sub-admin details from API and open edit modal
  const handleEdit = async (admin) => {
    setEditPasswords({ password: '', confirmPassword: '' });
    setEditLoading(true);
    setEditError(null);
    try {
      // Replace with your actual API endpoint for sub-admin details
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/super/admin/get/subadmin/${admin._id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      console.log("Fetch subAdmin details Response:", response);
      if (response.status === 200 && response.data && response.data.data) {
        const subAdmin = response.data.data;
        setEditForm({
          name: subAdmin.name || '',
          email: subAdmin.email || '',
          mobileNumber: subAdmin.mobileNumber || '',
          role: subAdmin.role || '',
          accessPaths: Array.isArray(subAdmin.accessPaths) ? subAdmin.accessPaths : [],
          assignedSections: Array.isArray(subAdmin.assignedSections) ? subAdmin.assignedSections : [],
        });
        setEditModal({ open: true, admin });
      } else {
        setEditError('Failed to fetch sub-admin details');
        toast.error('Failed to fetch sub-admin details');
      }
    } catch (err) {
      setEditError('Error fetching sub-admin details');
      toast.error('Error fetching sub-admin details');
    } finally {
      setEditLoading(false);
    }
  };

  // Handle form input change
  const handleEditInputChange = (e) => {
    // For password fields
    if (e.target.name === 'password' || e.target.name === 'confirmPassword') {
      setEditPasswords((prev) => ({ ...prev, [e.target.name]: e.target.value }));
      return;
    }
    const { name, value } = e.target;
    if (name === 'accessPaths') {
      setEditForm((prev) => ({ ...prev, accessPaths: value.split(',').map(v => v.trim()).filter(v => v) }));
    } else if (name === 'assignedSections') {
      setEditForm((prev) => ({ ...prev, assignedSections: value.split(',').map(v => v.trim()).filter(v => v) }));
    } else {
      setEditForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Update admin details
  const handleUpdateAdmin = async () => {
    if (!editModal.admin) return;
    setEditLoading(true);
    setEditError(null);
    // Password validation
    if (editPasswords.password !== editPasswords.confirmPassword) {
      setEditError('Passwords do not match');
      return;
    }
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/super/admin/update/subadmin/${editModal.admin._id}`,
        {
          name: editForm.name,
          email: editForm.email,
          mobileNumber: editForm.mobileNumber,
          role: editForm.role,
          accessPaths: editForm.accessPaths,
          assignedSections: editForm.assignedSections,
          password: editPasswords.password,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      if (response.status === 200) {
        toast.success('Admin updated successfully');
        // Update admin in list
        setAdmins((prevAdmins) =>
          prevAdmins.map((adm) =>
            adm._id === editModal.admin._id ? { ...adm, ...editForm } : adm
          )
        );
        setEditModal({ open: false, admin: null });
      } else {
        setEditError('Failed to update admin');
        toast.error('Failed to update admin');
      }
    } catch (err) {
      setEditError('Error updating admin');
      toast.error('Error updating admin');
    } finally {
      setEditLoading(false);
    }
  };

  return (
    <div className="p-4 sm:p-6 md:p-8">
      <h2 className="text-xl sm:text-2xl font-bold mb-4 text-gray-800">All Admins</h2>

      {loading && (
        <div className="flex justify-center items-center py-8">
          <span className="text-blue-600 font-semibold">Loading admins...</span>
        </div>
      )}

      {error && (
        <div className="flex justify-center items-center py-4">
          <span className="text-red-600 font-semibold">{error}</span>
        </div>
      )}

      {!loading && !error && (
        <div className="overflow-x-auto rounded-lg shadow">
          <table className="min-w-[1000px] w-full divide-y divide-gray-200 bg-white">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Admin</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Role</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Phone</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {admins.map((admin, idx) => (
                <tr key={admin._id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center">
                        <FontAwesomeIcon icon={faUserShield} className="text-blue-600" />
                      </div>
                      <div className="ml-4">
                        <div className="text-sm font-medium text-gray-900">{admin.name}</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-purple-100 text-purple-800">
                      {admin.role}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
                    {admin.email}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {admin.mobileNumber}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex flex-wrap gap-2">
                      <button
                        className="bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600 text-sm"
                        onClick={() => handleEdit(admin)}
                      >
                        Edit
                      </button>
                      <button
                        className="bg-red-500 text-white px-4 py-1 rounded hover:bg-red-600 text-sm"
                        onClick={() => setDeleteModal({ open: true, adminId: admin._id })}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Edit Modal */}
      {editModal.open && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-xl shadow-2xl p-4 sm:p-8 w-full max-w-lg mx-2 sm:mx-4 text-left relative flex flex-col justify-center items-center">
            <h2 className="text-2xl font-bold mb-6 text-gray-800 text-center">Edit Subadmin</h2>
            <form className="w-full grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Name</label>
                <input type="text" name="name" value={editForm.name} onChange={handleEditInputChange} className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300" />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Email</label>
                <input type="email" name="email" value={editForm.email} onChange={handleEditInputChange} className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300" />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Phone</label>
                <input type="text" name="mobileNumber" value={editForm.mobileNumber} onChange={handleEditInputChange} className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300" />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Role</label>
                <input type="text" name="role" value={editForm.role} onChange={handleEditInputChange} className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300" />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Access Paths</label>
                <input type="text" name="accessPaths" value={editForm.accessPaths.join(', ')} onChange={handleEditInputChange} placeholder="Comma separated, e.g. /admin/create/subadmin,/admin/view" className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300" />
                <span className="text-xs text-gray-500">Multiple paths separated by comma</span>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Assigned Sections</label>
                <input type="text" name="assignedSections" value={editForm.assignedSections.join(', ')} onChange={handleEditInputChange} placeholder="Comma separated, e.g. reporter,manager" className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300" />
                <span className="text-xs text-gray-500">Multiple sections separated by comma</span>
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Password</label>
                <input type="password" name="password" value={editPasswords.password} onChange={handleEditInputChange} className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300" autoComplete="new-password" />
              </div>
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Confirm Password</label>
                <input type="password" name="confirmPassword" value={editPasswords.confirmPassword} onChange={handleEditInputChange} className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300" autoComplete="new-password" />
              </div>
              {editError && <div className="col-span-2 text-red-500 text-sm mt-2">{editError}</div>}
            </form>
            <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8 w-full">
              <button
                onClick={handleUpdateAdmin}
                className={`w-full sm:w-auto px-8 py-2 rounded-lg font-semibold transition bg-blue-500 text-white hover:bg-blue-600 ${editLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                disabled={editLoading}
              >
                {editLoading ? 'Updating...' : 'Update'}
              </button>
              <button
                onClick={() => setEditModal({ open: false, admin: null })}
                className="w-full sm:w-auto px-8 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 font-semibold transition"
              >
                Cancel
              </button>
            </div>
            <button
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-2xl"
              onClick={() => setEditModal({ open: false, admin: null })}
              aria-label="Close"
            >
              &times;
            </button>
          </div>
        </div>
      )}

      {/* Delete Modal */}
      {deleteModal.open && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-xl shadow-2xl p-8 w-full max-w-md mx-4 text-center relative">
            <h2 className="text-xl font-bold mb-4 text-gray-800">Confirm Delete</h2>
            <p className="mb-6 text-gray-600">Are you sure you want to delete this admin?</p>
            <div className="flex items-center justify-center mb-6">
              <label className="flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={isDeleteChecked}
                  onChange={e => setIsDeleteChecked(e.target.checked)}
                  className="mr-3 h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
                />
                <span className="text-sm text-gray-700">I confirm this deletion</span>
              </label>
            </div>
            <div className="flex justify-center gap-4">
              <button
                onClick={async () => {
                  if (isDeleteChecked) {
                    await handleDelete(deleteModal.adminId);
                    setDeleteModal({ open: false, adminId: null });
                    setIsDeleteChecked(false);
                  }
                }}
                className={`px-6 py-2 rounded-lg font-semibold transition ${isDeleteChecked ? "bg-red-500 text-white hover:bg-red-600" : "bg-gray-300 text-gray-500 cursor-not-allowed"}`}
                disabled={!isDeleteChecked}
              >
                Yes, Delete
              </button>
              <button
                onClick={() => {
                  setDeleteModal({ open: false, adminId: null });
                  setIsDeleteChecked(false);
                }}
                className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 font-semibold transition"
              >
                Cancel
              </button>
            </div>
            <button
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-2xl"
              onClick={() => {
                setDeleteModal({ open: false, adminId: null });
                setIsDeleteChecked(false);
              }}
              aria-label="Close"
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default GetAllAdmins;
